import { useLocation } from "react-router-dom";
import { destinations } from "../components/Booking/Info";
import { useRecoilState, useSetRecoilState } from "recoil";
import { emailState, firstNameState, lastNameState } from "../events/recoils";
import { useRefundableActions } from "protect-group-pulse-react";
import { protectionState } from "../events/recoils";

export default function useConfirmBooking() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pathParts = location.pathname.split("/");
    const originCode = pathParts[2];
    const destinationCode = pathParts[3];
    const numPassengers = parseInt(searchParams.get("passengers")) || 1;
    const selectedDate = searchParams.get("date") || new Date().toISOString().split('T')[0];
    const [firstName, setFirstName] = useRecoilState(firstNameState);
    const [lastName, setLastName] = useRecoilState(lastNameState);
    const [email, setEmail] = useRecoilState(emailState);
    const { writeSale, saleComplete } = useRefundableActions();
    const setRefundState = useSetRecoilState(protectionState);

    const customers = Array.from({ length: numPassengers }, () => ({
        firstName,
        lastName,
        email,
        telephone: "+91 123456789"
    }));

    const isValidForm = () => {
        return firstName.trim() !== "" && lastName.trim() !== "" && email.trim() !== "";
    }

    const formatCardNumber = (input) => {
        return input.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1-');
    };

    const formatExpirationDate = (input) => {
        return input.replace(/\D/g, '').replace(/(\d{2})(\d)/, '$1/$2').replace(/(\d{2})\/(\d{4}).*/, '$1/$2');
    };

    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
    };

    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const generateUniqueReference = () => {
        const randomNumber = Math.floor(Math.random() * 900000) + 100000;
        return `BOOK-${randomNumber}`;
    };

    const theBookingRef = generateUniqueReference()

    const handleMakePayment = async () => {
        try {
            const request = {
                bookingReference:  theBookingRef,
                customers: customers,
                flights: [
                    {
                        arrivalCode: destinationCode,
                        departureCode: originCode,
                        departureDate: selectedDate,
                        flightNumber: 'AA1',
                        terminal: 'Terminal 1'
                    }
                ]
            };

            const response = await writeSale(request);

            saleComplete();

            setRefundState((prevState) => ({
                ...prevState,
                refundableConfirmationHtml: response.refundableConfirmationHtml,
                refundableLink: response.refundableLink,
                saleId: response.saleId
            }));

        } catch (error) {
            console.error("Error during payment:", error);
        }
    };

    return {
        originCode,
        destinationCode,
        destinations,
        handleMakePayment,
        formatCardNumber,
        formatExpirationDate,
        handleFirstNameChange,
        handleLastNameChange,
        handleEmailChange,
        isValidForm,
        selectedDate,
        numPassengers,
        theBookingRef,
    }
}